module.exports = __webpack_public_path__ + "static/zwanger-buik-897c0e41f18b5f14253343ceb423cd61.jpg";